import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getData } from "../../services/generalService";
import { DelinquencySetObj } from "../../utils/types";

const initialState: DelinquencySetObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getDelinquencySetByID = createAsyncThunk(
  "loans/getDelinquencySet",
  async (url: string, thunkAPI) => {
    try {
      const data = await getData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const delinquencySetByIDSlice = createSlice({
  name: "delinquencySet",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDelinquencySetByID.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDelinquencySetByID.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getDelinquencySetByID.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default delinquencySetByIDSlice.reducer;
